var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.5C7.27614 0.5 7.5 0.723858 7.5 1L7.5 13C7.5 13.2761 7.27614 13.5 7 13.5C6.72386 13.5 6.5 13.2761 6.5 13L6.5 1C6.5 0.723858 6.72386 0.5 7 0.5Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 7C13.5 7.27614 13.2761 7.5 13 7.5L1 7.5C0.723858 7.5 0.5 7.27614 0.5 7C0.5 6.72386 0.723858 6.5 1 6.5L13 6.5C13.2761 6.5 13.5 6.72386 13.5 7Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c969197c1cfcf5875b895371b1926095.svg";
export { ForwardRef as ReactComponent };